<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
  @import './common/index.css';
  @import './common/animation.css';
  .about_line {
    width: 47px;
    height: 1px;
    margin: 14px auto 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue